"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.SingleDatePicker = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _Paper = _interopRequireDefault(require("@material-ui/core/Paper"));
var _styles = require("@material-ui/core/styles");
require("@proofpoint/react-dates/initialize");
require("@proofpoint/react-dates/lib/css/_datepicker.css");
var _reactDates = require("@proofpoint/react-dates");
var _classnames = _interopRequireDefault(require("classnames"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _withReactDatesStyles = _interopRequireDefault(require("../../theme/react-dates/withReactDatesStyles"));
var _excluded = ["classes", "className", "dataMetrics", "date", "focused", "initialVisibleMonth", "isOutsideRange", "onDateChange"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var styles = function styles( /* theme */
) {
  return {
    paper: {
      borderRadius: 2,
      paddingBottom: 8,
      paddingTop: 8,
      width: 340
    },
    root: {
      height: 364,
      width: 340
    }
  };
};
var defaultProps = {
  classes: {},
  dataMetrics: {
    root: 'fuse_single_date_picker'
  }
};

/**
 * The SingleDatePicker is a fully controlled component that allows users to
 * select a single date. You can control the selected date using the `date` and
 * `onDateChange` props as shown below.
 */
var SingleDatePicker = /*#__PURE__*/_react["default"].forwardRef(function (_ref, ref) {
  var classes = _ref.classes,
    className = _ref.className,
    dataMetrics = _ref.dataMetrics,
    date = _ref.date,
    focused = _ref.focused,
    initialVisibleMonth = _ref.initialVisibleMonth,
    isOutsideRange = _ref.isOutsideRange,
    onDateChange = _ref.onDateChange,
    rest = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  var mergedDataMetrics = _objectSpread({}, defaultProps.dataMetrics, {}, dataMetrics);
  return /*#__PURE__*/_react["default"].createElement(_Paper["default"], {
    className: (0, _classnames["default"])(classes.paper, className),
    "data-metrics": mergedDataMetrics.root,
    elevation: 9
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _classnames["default"])(classes.root)
  }, /*#__PURE__*/_react["default"].createElement(_reactDates.DayPickerSingleDateController
  // Received props
  , (0, _extends2["default"])({
    date: date,
    focused: focused,
    initialVisibleMonth: initialVisibleMonth,
    isOutsideRange: isOutsideRange,
    onDateChange: onDateChange
    // Override props
    ,
    numberOfMonths: 1,
    ref: ref
  }, rest))));
});
exports.SingleDatePicker = SingleDatePicker;
SingleDatePicker.defaultProps = defaultProps;
SingleDatePicker.displayName = 'SingleDatePickerClass';
SingleDatePicker.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * Override or extend the styles applied to the component.
   */
  classes: _propTypes["default"].object,
  /**
   * @ignore
   */
  className: _propTypes["default"].string,
  /**
   * Override the data-metrics attributes applied to the component.
   */
  dataMetrics: _propTypes["default"].shape({
    root: _propTypes["default"].string
  }),
  /**
   * The date selected.
   */
  date: _propTypes["default"].object,
  /**
   * Indicate if the picker's input is focused
   */
  focused: _propTypes["default"].bool,
  /**
   * The initial visible month to show
   */
  initialVisibleMonth: _propTypes["default"].func,
  /**
   * A predicate function that returns if the date is valid, which would allow
   * you to restrict which dates are selectable.
   *
   * @param {object} date the date to be evaluated if it is outside of the range
   */
  isOutsideRange: _propTypes["default"].func,
  /**
   * @ignore
   */
  navNext: _propTypes["default"].element.isRequired,
  /**
   * @ignore
   */
  navPrev: _propTypes["default"].element.isRequired,
  /**
   * Callback fired when the date is changed.
   *
   * @param {object} date the date changed. (Moment Object)
   */
  onDateChange: _propTypes["default"].func,
  /**
   * @ignore
   */
  renderDayContents: _propTypes["default"].func.isRequired,
  /**
   * @ignore
   */
  renderMonthElement: _propTypes["default"].func.isRequired
} : {};
var ExportComponent = (0, _withReactDatesStyles["default"])((0, _styles.withStyles)(styles)(SingleDatePicker));
ExportComponent.displayName = 'SingleDatePicker';
var _default = ExportComponent;
exports["default"] = _default;